import { useStaticQuery, graphql } from "gatsby"

export const useFooter = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allMenuLinkContentMenuLinkContent(
          sort: { fields: weight, order: ASC }
          filter: { enabled: { eq: true }, menu_name: { eq: "footer" } }
        ) {
          edges {
            node {
              title
              link {
                uri
              }
            }
          }
        }
      }
    `
  )
  return data
}
